import axios from 'axios'
import { Nullable } from '@/shared/types/app.types'
import {
    ConfigurationIncidentOriginLaboratoryDefaultPersonnelRequest,
    ConfigurationIncidentOriginLaboratoryDefaultPersonnelResponse
} from '@/modules/configurationModule/detail/incidents/incidents-origins/services/incidents-origins-default-personnel-relationship.dto'
import { EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class IncidentsOriginsLaboratoriesPersonnelRelationship {
    async getIncidentsOriginsLaboratoryDefaultPersonnelRelationships(laboratoryId: number, incidentsOriginsLaboratoryId: number): Promise<ConfigurationIncidentOriginLaboratoryDefaultPersonnelResponse> {
        const response = await axios.get<ConfigurationIncidentOriginLaboratoryDefaultPersonnelResponse>(`/configuration/laboratories/${laboratoryId}/incidentOriginLaboratories/${incidentsOriginsLaboratoryId}/incidentOriginLaboratoryDefaultPersonnel`)
        return response.data
    }

    async createIncidentsOriginsLaboratoryDefaultPersonnel(laboratoryId: number, request: ConfigurationIncidentOriginLaboratoryDefaultPersonnelRequest): Promise<ConfigurationIncidentOriginLaboratoryDefaultPersonnelResponse> {
        const response = await axios.post<ConfigurationIncidentOriginLaboratoryDefaultPersonnelResponse>(`/configuration/laboratories/${laboratoryId}/incidentOriginLaboratoryDefaultPersonnel`, request)
        return response.data
    }

    async deleteIncidentsOriginsLaboratoryDefaultPersonnel(laboratoryId: number, incidentOriginLaboratoryDefaultPersonnelId: Nullable<number>): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/incidentOriginLaboratoryDefaultPersonnel/${incidentOriginLaboratoryDefaultPersonnelId}`)
        return response.data
    }
}

export const incidentsOriginsLaboratoriesPersonnelRelationship = new IncidentsOriginsLaboratoriesPersonnelRelationship()
